/**
 * Created by senani on 12/20/18.
 */

import React, {Component} from 'react';
import './OrderItemRow.css';
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import No_Image from "../../../../assets/img/NO_IMAGE.png";

class OrderItemRow extends Component {

    render() {
        let pcbParams = this.props.item.quotation.pcbParam;
        let stencilParams = this.props.item.quotation.stencilParam;
        let charges = this.props.item.chargeDetails;

        // console.log("CHARGES DUO ====> ",this.props.item);

        return (

            <div className="row">
                <div className="col-md-1">
                    <span>{this.props.rowNo}</span>
                </div>
                {this.props.item.reviewResult ?
                <div className="col-md-2">
                    <span>
                        <img src={this.props.item.gerberDto.imageUrlTop} width={100}/>
                    </span>
                </div>:
                    <div className="col-md-2">
                      <span>
                        <img src={No_Image} width={100}/>
                      </span>
                    </div>
                }
                <div className="col-md-2">
                    <span>{this.props.item.itemName}</span>
                </div>
                <div className="col-md-2">
                    {this.props.item.quotation.orderType === 1 &&
                    <span className="pull-right"><span className="pcb-stencil-qty-resp">PCB : &nbsp;{pcbParams.qty}</span></span>
                    }
                    {this.props.item.quotation.orderType === 2 &&
                    <span className="pull-right"><span className="pcb-stencil-qty-resp">PCB : &nbsp;{pcbParams.qty}</span><br/>SMTメタルマスク : &nbsp;<span className="pcb-stencil-qty-resp">{stencilParams.stencilQty}</span></span>
                    }
                    {this.props.item.quotation.orderType === 3 &&
                    <span className="pull-right">SMTメタルマスク : &nbsp;<span className="pcb-stencil-qty-resp">{stencilParams.stencilQty}</span></span>
                    }
                </div>
                <div className="col-md-3">
                    <span className="pull-right">¥ <NumberFormatter num={charges.priceInfoJson}/></span>
                </div>

                <div className="col-md-2">
                    <span className="pull-right">¥ <NumberFormatter
                        num={this.props.item.chargeDetails.totalPrice}/></span>
                </div>
            </div>

        )
    }
}

export default OrderItemRow;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderItemRow/OrderItemRow.js